export enum Roles {
    ROLE_ADMIN = "ADMIN",
    ROLE_USER = "USER",
    ROLE_MODERATOR = "MODERATOR",
    ROLE_SUPER_ADMIN = "SUPER_ADMIN"
}
